module.exports = __webpack_public_path__ + "static/media/_france.8b296b78.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_france.svg
// module id = 2321
// module chunks = 7